/**
 * La puerta de los enlaces que llegan de afuera: `/ir/:negocio/*` (3-nov-2026).
 *
 * Un aviso de WhatsApp apunta a un chat de UN negocio, pero el panel abre todo con el negocio ACTIVO. El founder tenía
 * activo Smarty HQ, tocó el aviso de Dulti y cayó en «Conecta WhatsApp a tu negocio», como si Dulti no tuviera WhatsApp.
 * Por acá se entra al negocio del enlace y recién entonces se abre lo que pide.
 *
 * 🪤 NO VA EN `StoreGuard`. El selector de negocios cambia el activo y deja la URL con la tienda anterior; es `StoreGuard`
 *    el que, al ver que no coinciden, lo lleva al tablero del negocio nuevo. Si ese guardia cambiara al negocio de la URL,
 *    el selector volvería siempre al negocio del que se quiso salir.
 *
 * 🚨 CAMBIA Y RECARGA, no se queda en la misma página. Al abrir una pestaña, `AuthContext` da por bueno el negocio guardado
 *    y sigue resolviéndolo en segundo plano. Esa respuesta llegaba después del cambio y lo pisaba: en el panel real el enlace
 *    mostró Dulti un instante y terminó en el tablero de Smarty HQ. Desde el selector no se nota porque nadie alcanza a
 *    tocarlo tan rápido. Con la recarga no queda ninguna consulta vieja, y el arranque toma el negocio nuevo de
 *    `lastActiveTenantId`, que `switchTenant` ya guardó y esa respuesta no toca.
 *
 * Sin acceso a ese negocio se entra al tablero propio, igual que con cualquier otra tienda ajena en la URL.
 */
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '@smarty/shared';
import { storePath } from '@/config/routes.config';
import { RedirectLoading } from '@/components/RedirectLoading';

export function EntrarAlNegocio() {
  const { negocio = '', '*': resto = '' } = useParams();
  const { search, hash } = useLocation();
  const navigate = useNavigate();
  const { loading, storeSlug, tenants, switchTenant, refreshTenants } = useAuth();
  // La lista de negocios llega después de la sesión: que todavía no esté no quiere decir que no tenga acceso.
  const [listaAlDia, setListaAlDia] = useState(false);
  const pidioLaLista = useRef(false);
  const saliendo = useRef(false);

  useEffect(() => {
    if (loading || !storeSlug || saliendo.current) return;
    const loQuePidio = `${storePath(negocio, resto)}${search}${hash}`;
    if (storeSlug === negocio) {
      navigate(loQuePidio, { replace: true });
      return;
    }
    const destino = tenants.find((t) => t.slug === negocio);
    if (destino) {
      saliendo.current = true;
      switchTenant(destino.id)
        .then(() => window.location.replace(loQuePidio))
        .catch(() => navigate(storePath(storeSlug, ''), { replace: true }));
      return;
    }
    if (listaAlDia) {
      navigate(storePath(storeSlug, ''), { replace: true });
      return;
    }
    if (pidioLaLista.current) return;
    pidioLaLista.current = true;
    void refreshTenants().finally(() => setListaAlDia(true));
  }, [loading, storeSlug, negocio, resto, search, hash, tenants, listaAlDia, navigate, switchTenant, refreshTenants]);

  return <RedirectLoading />;
}
